































































import { defineComponent, PropType, toRefs, computed, ref } from '@vue/composition-api';
import Vue from 'vue';
import { AdgroupFormData, CampaignFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import {
  useVisible,
  useIsEcomShop,
  useSelectedSpu,
  useAction,
  useShopInfo,
  useMaxProductsNum,
  getProductAmount,
} from './hooks';
import ProductSelectMain from './subcpn/main.vue';

const name = 'ttam-product-select-from-shop-compose';
export default defineComponent({
  name,
  components: {
    ProductSelectMain,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isRtl: {
      type: Boolean,
      default: false,
    },
    topHeight: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, visible, isRtl } =
      toRefs<{
        adgroupData: AdgroupFormData;
        campaignData: CampaignFormData;
        creativeData: FullNormalFormData;
        visible: boolean;
        isRtl: boolean;
      }>(props);

    const shopInfo = useShopInfo({ adgroupData });
    const isEcomShop = useIsEcomShop(shopInfo);
    const isSingleSelect = ref(false);
    const { spuListAmount } = getProductAmount({
      adgroupData,
      campaignData,
      shopInfo,
    });

    const _topHeight = computed(() => props.topHeight ?? Vue.prototype.$TTAMUI?.headerHeight);

    const spuDetailList = computed(() => creativeData.value.spuDetailList);
    const { selectedSpuList, resetSelected } = useSelectedSpu({
      spuDetailList,
    });

    const { slipVisible, slideTransition } = useVisible({
      visible,
      isRtl,
      emit,
      resetSelected,
    });

    const { back, confirm } = useAction({
      selectedSpuList,
      emit,
      slipVisible,
    });

    const { maxProductsNum: selectNumLimit } = useMaxProductsNum({
      adgroupData,
      campaignData,
      isSingleSelect,
    });

    return {
      name,
      shopInfo,
      isEcomShop,
      selectedSpuList,
      isSingleSelect,
      slipVisible,
      slideTransition,
      selectNumLimit,
      back,
      confirm,
      _topHeight,
      spuListAmount,
    };
  },
});
